import { Component, Inject, Injector, ChangeDetectionStrategy } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { jkRestReturn } from 'jk-service';
import { MaterialModule } from 'jk-service';
import { TaxwcService, templateUrlConfigTax } from './../_service_tax';
import { Taxwc } from './../_entity_tax';
import { JkDialogEditComponent } from 'jk-service';
import { JackBaseComponentModule } from 'jk-service';
import { JkbtneditComponent } from 'jk-advcom';


@Component({
  selector: 'app-taxwc-edit',
  templateUrl: './taxwc-editPkg.component.html',
  styleUrls: [],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [JackBaseComponentModule, JkbtneditComponent, MaterialModule],
})

export class TaxwcEditComponent extends JkDialogEditComponent<TaxwcService, Taxwc> {
  override srv!: TaxwcService;
  constructor(
    inject: Injector,
    public override dialogRef: MatDialogRef<TaxwcEditComponent>,
    @Inject(MAT_DIALOG_DATA)
    public override data: jkRestReturn
  ) {
    super(inject, dialogRef,data);
  }


}
